import {register} from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('featured-collection-section', {
  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `.collection-carousel--${id}`;
    const desktopSlides = parseInt(
      document.querySelector(target).dataset.desktopSlides,
    );
    const mobileSlides = parseInt(
      document.querySelector(target).dataset.mobileSlides,
    );
    new Swiper(target, {
      slidesPerView: desktopSlides,
      loop: true,
      freeMode: false,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: 'true',
      },
      breakpoints: {
        300: {
          slidesPerView: mobileSlides,
          spaceBetween: 10,
          centeredSlides: false,
          centeredSlidesBounds: true,
          freeModeSticky: true,
        },
        440: {
          slidesPerView: mobileSlides,
          spaceBetween: 10,
          centeredSlides: false,
        },
        753: {
          slidesPerView: 3,
          spaceBetween: 35,
          centeredSlides: false,
        },
        822: {
          slidesPerView: 4,
          spaceBetween: 32,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: desktopSlides,
          spaceBetween: 32,
          centeredSlides: false,
        },
      },
    });
  },
});
